import { FC } from "react"

import SidePanel from "../side-panel"
import If from "../if"
import SafeHTMLRenderer from "../safe-html-renderer"
import { useFetchPrintEmailQuery } from "../../../redux/queries"

interface Props {
  open: boolean
  id: string
  onClose: () => void
}

const RateAlertModal: FC<Props> = ({ open, id, onClose }) => {
  const { data: emailHtmlData, isFetching } = useFetchPrintEmailQuery(
    { id: id },
    { skip: !id }
  )

  return (
    <SidePanel open={open} title="Rate alert email" onClose={onClose}>
      <div className="h-full flex flex-col">
        <div className="bg-white">
          <If
            isLoading={isFetching}
            condition={!!emailHtmlData}
            then={
              <SafeHTMLRenderer htmlContent={emailHtmlData!} isText={false} />
            }
            else={<div className="pt-6">No rate alert email found.</div>}
            loaderClassName="pt-6"
          />
        </div>
      </div>
    </SidePanel>
  )
}

export default RateAlertModal
